var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBuildingsLargeEnterprise(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-1970.000000, -437.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Buildings/Large-enterprise",
    transform: "translate(1970.000000, 437.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23,0 L23,9.4 L32,13 L32,28.085 C32,30.247 30.247,32 28.085,32 L28.085,32 L15,32 L15,0 L23,0 Z M8.667,14.667 C10.245,14.667 11.722,14.826 13,15.098 L13,15.098 L13,32 L0,32 L0,17.839 C0,16.094 3.9,14.667 8.667,14.667 Z M11,28 L2.133,28 L2.133,29 L11,29 L11,28 Z M11,25 L2.133,25 L2.133,26 L11,26 L11,25 Z M19,23 L17,23 L17,25 L19,25 L19,23 Z M30,21 L23,21 L23,23 L30,23 L30,21 Z M11,22 L2.133,22 L2.133,23 L11,23 L11,22 Z M19,19 L17,19 L17,21 L19,21 L19,19 Z M30,18 L23,18 L23,20 L30,20 L30,18 Z M11,19 L2.133,19 L2.133,20 L11,20 L11,19 Z M30,15 L23,15 L23,17 L30,17 L30,15 Z M19,15 L17,15 L17,17 L19,17 L19,15 Z M19,11 L17,11 L17,13 L19,13 L19,11 Z M19,7 L17,7 L17,9 L19,9 L19,7 Z M19,3 L17,3 L17,5 L19,5 L19,3 Z",
    id: 61
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingsLargeEnterprise);
export default __webpack_public_path__ + "static/media/buildings-large-enterprise.a3291d1b.svg";
export { ForwardRef as ReactComponent };